import CodeBlock from "./../code-block";

//this is the superClass for primitive models
//a primitive simply holds a value of a specific type
export default CodeBlock.extend({});
